/**
 * Progressive i18n setup (react-i18next).
 *
 * Currently translated: sidebar, Dashboard, Settings, SetCommissions.
 * Other pages will be added in subsequent iterations. When a key is missing
 * the English fallback is used so nothing renders as "[key not found]".
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en";
import es from "./locales/es";
import fr from "./locales/fr";
import ht from "./locales/ht";

export const SUPPORTED_LANGUAGES = [
  { code: "en", label: "English",  flag: "US" },
  { code: "es", label: "Español",  flag: "ES" },
  { code: "fr", label: "Français", flag: "FR" },
  { code: "ht", label: "Kreyòl",   flag: "HT" },
];

const STORAGE_KEY = "globetopup.lang";

export function getStoredLanguage() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return SUPPORTED_LANGUAGES.find((l) => l.code === v) ? v : "en";
  } catch { return "en"; }
}

export function setStoredLanguage(code) {
  try { localStorage.setItem(STORAGE_KEY, code); } catch (_e) { /* ignore quota / SecurityError */ }
  i18n.changeLanguage(code);
}

i18n
  .use(initReactI18next)
  .init({
    resources: { en, es, fr, ht },
    lng: getStoredLanguage(),
    fallbackLng: "en",
    interpolation: { escapeValue: false }, // React already escapes
    returnEmptyString: false,
    returnNull: false,
  });

export default i18n;
